import propTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { MdChevronRight, MdLockOpen } from 'react-icons/md';
import {
  INVITE_BRAND_VARIANTS,
  INVITE_PATHS,
  buildInvitePath,
} from '../../constants';
import * as S from './styles';

const SmartLockCta = ({ guestHash, variant }) => {
  const [t] = useTranslation('invite');
  const history = useHistory();

  const handleOpenSmartLockPage = () =>
    history.push(buildInvitePath(INVITE_PATHS.SMART_LOCK, guestHash));

  return (
    <S.Button
      type="button"
      $variant={variant}
      onClick={handleOpenSmartLockPage}
    >
      <S.IconWrapper $variant={variant}>
        <MdLockOpen size={24} />
      </S.IconWrapper>
      <S.Content>
        <S.Title>{t('smart-lock.cta.title')}</S.Title>
        <S.Description>{t('smart-lock.cta.description')}</S.Description>
      </S.Content>
      <MdChevronRight size={24} />
    </S.Button>
  );
};

SmartLockCta.propTypes = {
  guestHash: propTypes.string.isRequired,
  variant: propTypes.oneOf(Object.values(INVITE_BRAND_VARIANTS)).isRequired,
};

export default SmartLockCta;
